import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import * as Highcharts from 'highcharts';
import { AnalyticsService } from '../../../shared/providers/analytics.service';
import { Subscription } from 'rxjs';

declare var require: any;
if (typeof Highcharts === 'object') {

  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}
interface IWatchListData {
  name: string;
  Id: number;
  data: [];
}

@Component({
  selector: 'app-market-snapshot-chart',
  templateUrl: './Market-Snapshot-Chart.component.html',
  styleUrls: ['./Market-Snapshot-Chart.component.css']
})
export class MarketSnapshotChartComponent implements OnInit, OnDestroy {
  currentMenu = '';
  constructor(private Analytics: AnalyticsService, public Validation: ValidationService, public authentication: AuthenticationService) {
  }

  chartData: IWatchListData = {} as any;
  user: any;
  myportfolioData = [] as any;
  propertyTypeData = [] as any;
  barchartData = [] as any;
  selectedDuration = 1;
  highlightData = [] as any;
  currentUser: any;
  months = [];
  TypeBasedData = [];
  showLoader: boolean;
  minimumValue: number = 0;
  IschartLoaded: number = 0;
  @Input() UserGuid: string;
  @Input() PortfolioName: string = 'My Portfolio';
  subscription: Subscription;

  ngOnInit() {
    this.showLoader = true;
    this.user = this.authentication.user;
    this.UserGuid = this.UserGuid != '' && this.UserGuid != null ? this.UserGuid : '0000';
    this.user = this.authentication.user;
    this.getMonths()
    if (localStorage.getItem('PropertyTypesValues') != null && localStorage.getItem('PropertyTypesValues') != undefined) {
      this.getChartData();
    }
    else {
      this.getAllChartData();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getChartData() {
    this.subscription= this.Analytics.GetPortfoliochartData(this.user.Id, this.UserGuid).subscribe(response => {
      let data = response;
      this.myportfolioData = [] as any;
      this.myportfolioData = data;
      let newPortfolio = [] as any;
      let chatDataColor = 0;
      let num1 = 0;
      let avgCapRate = [];
      this.minimumValue = 0;
      let graphMin = 0;

      if (data != null && data.length > 0) {
        this.months.forEach(t => {
          let avg = num1 <= 12 ? data.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[0] : data.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[1];
          avgCapRate.push(avg);
          num1 = num1 + 1;
        });
        newPortfolio = [{
          name: this.UserGuid == '0000' ? 'My Portfolio' : this.user.Guid == this.UserGuid ? 'My Portfolio' : 'Portfolio',
          data: avgCapRate.map(i => i),
          color: '#02C29F',
          marker: {
            "symbol": "circle"
          }
        }];
        if (avgCapRate != null && avgCapRate != undefined && avgCapRate.length > 0) {
          graphMin = avgCapRate.reduce((a, b) => Math.min(a, b));
        }
        chatDataColor++;
      }

      let propertyChartTypeData = JSON.parse(localStorage.getItem('PropertyTypesValues'));
      if (propertyChartTypeData != null && propertyChartTypeData.length > 0) {
        this.Analytics.GetMarketchartTypeCurrentMonths().subscribe(response1 => {
          if (response1 != null && response1 != undefined) {
            response1.forEach(s => {
              propertyChartTypeData.push(s);
            });
            this.propertyTypeData = propertyChartTypeData;
            if (this.propertyTypeData != null && this.propertyTypeData.length > 0) {
              let propertyTypeIds = this.propertyTypeData.filter(d => d.Id).map(i => i.Id);
              propertyTypeIds = propertyTypeIds.map(ar => JSON.stringify(ar))
                .filter((itm, idx, arr) => arr.indexOf(itm) === idx)
                .map(str => JSON.parse(str));
              propertyTypeIds.forEach(s => {
                let num = 0;
                let monthlydata = [];
                let data1 = this.propertyTypeData.filter(x => x.Id == s);
                let name = data1.map(i => i.Name)[0];
                this.months.forEach(t => {
                  this.TypeBasedData = num <= 12 ? data1.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[0] : data1.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[1];
                  monthlydata.push((this.TypeBasedData != null && this.TypeBasedData != undefined) ? this.TypeBasedData : 0);
                  num = num + 1;
                });
                let typeColor = name == 'Medical' ? '#FF4438' : name == 'Office' ? '#FFC32B' : name == 'Industrial' ? '#003A5D' : name == 'Retail' ? '#198FDE' : this.getChartColor(chatDataColor)
                let newPortfolio1 = {
                  name: name,
                  data: monthlydata.map(i => i),
                  color: typeColor,
                  marker: {
                    "symbol": "circle"
                  }
                };
                if (monthlydata != null && monthlydata != undefined && monthlydata.length > 0) {
                  let newminimumValue = monthlydata.reduce((a, b) => Math.min(a, b));
                  graphMin = (avgCapRate != null && avgCapRate != undefined && avgCapRate.length > 0) ? (newminimumValue != null && newminimumValue != undefined) ? (newminimumValue < graphMin) ? newminimumValue : graphMin : graphMin : newminimumValue;
                  this.minimumValue = graphMin > 1 ? (graphMin - 1) : graphMin;
                }
                else {
                  this.minimumValue = graphMin > 1 ? (graphMin - 1) : graphMin;
                }
                chatDataColor++;
                newPortfolio.push(newPortfolio1);
              });
              this.barchartData = newPortfolio;
              this.showLoader = false;
              this.bindChart();
            }
          }
        });
      }
    });
  }

  bindChart() {
    let myData = this.myportfolioData;
    let myPropertyData = this.propertyTypeData;
    const chart: Highcharts.Options = {
      chart: {
        height: 300,
        type: 'spline'
      },

      title: {
        text: ''
      },
      xAxis: {
        categories: this.months.map(i => i),
        crosshair: true,
        title: {
          text: ''
        },
        labels: {
          style: {
            color: '#A34646'
          }
        }

      },
      yAxis: {
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        tickInterval: 0.5,
        min: this.minimumValue,
        title: {
          text: ''
        },
        labels: {
          format: '{value}%'

        },
      },
      legend: {
        enabled: true,
        itemStyle: {
          fontWeight: 'normal',
          color: '#A34646'
        }
      },
      credits: {
        enabled: false
      },

      tooltip: {
        headerFormat: '',
        pointFormatter: function () {
          var point = this;
          var currentSeries = point.series;
          if (currentSeries.name == 'My Portfolio' || currentSeries.name == 'Portfolio') {
            let activelistingCount = myData.filter(i => i.XAxis == point.category).map(i => i.ActiveListing)[0];
            return '<table><tr><td padding:0"> My Portfolio </td></tr><tr><td padding:0"> # Properties : </td><td style="padding:0"><b>' + activelistingCount + '</b></td></tr><tr><td padding:0"> Avg Cap Rate : </td><td style="padding:0"><b>' + point.y + '%</b></td></tr>';

          }
          else {
            let activelistingCount = myPropertyData.filter(i => i.XAxis == point.category && i.Name == currentSeries.name).map(i => i.ActiveListing)[0];
            return '<table><tr><td padding:0">' + currentSeries.name + ' </td></tr><tr><td padding:0"> # Properties : </td><td style="padding:0"><b>' + activelistingCount + '</b></td></tr><tr><td padding:0"> Avg Cap Rate : </td><td style="padding:0"><b>' + point.y + '%</b></td></tr>';

          }
        },
        footerFormat: '</table>',
        shared: false,
        useHTML: true,
        shadow: false,
        
      },

      plotOptions: {
        line: {
          lineWidth: 2,
          states: {
            hover: {
              lineWidthPlus: 1, 
            },
          },
        },
      },
      series: this.barchartData,
    }
    if (document.getElementById('MarketSnapShotChart')) {
      Highcharts.chart('MarketSnapShotChart', chart);
      this.IschartLoaded = 1;
      this.getHighlight();
    }
  }


  getMonths() {
    var today = this.Validation.convertUTCDateToLocalDate1(new Date());
    let range = [];
    var newDate = today;
    let selectedValue = 11;
    let monthDigit = newDate.getMonth() - selectedValue;
    newDate = new Date(newDate.getFullYear(), monthDigit, 1);
    for (var i = newDate; i <= new Date(); i.setMonth(newDate.getMonth() + 1)) {
      var month = i.toLocaleString('en-us', { month: 'short' });;
      range.push(month);
    }
    this.months = range;
  }

  expandChart(div) {
    if ($('#' + div).hasClass('expand-div')) {
      window.scrollTo(0, 0);
      $('#' + div).removeClass('expand-div');
      $('body').removeClass('modal-open');

    }
    else {
      window.scrollTo(0, 0);
      $('#' + div).addClass('expand-div');
      $('body').addClass('modal-open');
    }
    this.getChartData();
  }


  getHighlight() {
    this.highlightData = [] as any;
    if (this.selectedDuration != null && this.barchartData != null && this.barchartData != undefined && this.barchartData.length > 0) {
      this.barchartData.forEach(s => {
        if (s != null) {
          let currentValue = 0;
          let previousValue = 0;
          let difference = 0;
          let TypeData = {} as any;
          let informationText = '';
          if (this.selectedDuration == 1) {
            currentValue = s.data[11];
            previousValue = s.data[10];
          }
          else if (this.selectedDuration == 3) {
            currentValue = s.data[11];
            previousValue = s.data[8];
          }
          else {
            currentValue = s.data[11];
            previousValue = s.data[5];
          }
          if (currentValue >= previousValue) {
            difference = currentValue - previousValue;
            let differenceText = difference.toFixed(2);
            if (difference > 0) {
              difference = parseFloat(difference.toFixed(2));
              let duration = (this.selectedDuration != null && this.selectedDuration > 0 && this.selectedDuration != undefined) ?
                this.selectedDuration == 1 ? ' % from the previous month.' : (' % from the previous ' + this.selectedDuration + ' months.') : ' % from the previous month.';
              informationText = 'The average asking cap rate has increased by ' + differenceText + duration;

              TypeData = { name: s.name, currentValue: currentValue, difference: difference, StatusId: 1, InfoText: informationText }
            }
            else {
              let duration = (this.selectedDuration != null && this.selectedDuration > 0 && this.selectedDuration != undefined) ?
                this.selectedDuration == 1 ? 'from the previous month.' : ('from the previous ' + this.selectedDuration + ' months.') : 'from the previous month.';
              informationText = 'The average asking cap rate has not changed ' + duration;
              TypeData = { name: s.name, currentValue: currentValue, difference: difference, StatusId: 0, InfoText: informationText }
            }
          }
          else {
            difference = previousValue - currentValue;
            let differenceText = difference.toFixed(2);
            if (difference > 0) {
              difference = parseFloat(difference.toFixed(2));
              let duration = (this.selectedDuration != null && this.selectedDuration > 0 && this.selectedDuration != undefined) ?
                this.selectedDuration == 1 ? ' % from the previous month.' : (' % from the previous ' + this.selectedDuration + ' months.') : ' % from the previous month.';
              informationText = 'The average asking cap rate has decreased by ' + differenceText + duration;
            }
            TypeData = { name: s.name, currentValue: currentValue, difference: difference, StatusId: 2, InfoText: informationText }
          }
          this.highlightData.push(TypeData);
        }
      })
    }
  }

  getChartColor(index) {
    const colors = [' #6596D6 ', ' #A34646 ', '#5167EA ', ' #67A7FA', '#277583', ' #1967CB ', ' #0D77FF ', ' #004298 ', ' #285CA1 ', ' #55759E ', ' #4788DC ', ' #5167EA ', ' #2B44D8 ', ' #7582CF ', ' #4354B9 ', ' #0F24A4 ', ' #1458E2 ', ' #3562BF ', ' #305297 ', ' #333286 ', ' #98C7FF ', ' #4886D8 ', ' #2C99D7 ', ' #157BB5 ', ' #0C6699 ', ' #49A1D3 ', ' #62BFF3 ', ' #51B5D1 ', ' #6186D3 ', ' #33C5DF ', ' #21A5BC ', ' #274183 ', ' #21459E ', ' #4674E6 ', ' #3355AA ', ' #596C9C ', ' #503C8D ', ' #6042BE ', ' #906CFF ', ' #B08CC8 ', ' #A374AE ', ' #B4658E ', ' #CA62DF ', ' #A264D9 ', ' #90B36C ', ' #6C963D ', ' #6AB16A ', ' #75D285 ', ' #B3BB66 ', ' #C77272 ', ' #D75555 ']
    return colors[index];
  }


  getAllChartData() {
    this.Analytics.GetPortfoliochartData(this.user.Id, this.UserGuid).subscribe(response => {
      let data = response;
      this.myportfolioData = [] as any;
      this.myportfolioData = data;
      let newPortfolio = [] as any;
      let chatDataColor = 0;
      let num1 = 0;
      let avgCapRate = [];
      this.minimumValue = 0;
      let graphMin = 0;

      if (data != null && data.length > 0) {
        this.months.forEach(t => {
          let avg = num1 <= 12 ? data.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[0] : data.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[1];
          avgCapRate.push(avg);
          num1 = num1 + 1;
        });
        newPortfolio = [{
          name: this.UserGuid == '0000' ? 'My Portfolio' : this.user.Guid == this.UserGuid ? 'My Portfolio' : 'Portfolio',
          data: avgCapRate.map(i => i),
          color: '#02C29F',
          marker: {
            "symbol": "circle"
          }
        }];
        if (avgCapRate != null && avgCapRate != undefined && avgCapRate.length > 0) {
          graphMin = avgCapRate.reduce((a, b) => Math.min(a, b));
        }
        chatDataColor++;
      }
      this.Analytics.GetMarketChartByTypes(this.user.Id).subscribe(response1 => {
        let TypeData = response1;
        this.propertyTypeData = response1;
        if (TypeData != null && TypeData.length > 0) {
          let propertyTypeIds = this.propertyTypeData.filter(d => d.Id).map(i => i.Id);
          propertyTypeIds = propertyTypeIds.map(ar => JSON.stringify(ar))
            .filter((itm, idx, arr) => arr.indexOf(itm) === idx)
            .map(str => JSON.parse(str));
          propertyTypeIds.forEach(s => {
            let num = 0;
            let monthlydata = [];
            let name = this.propertyTypeData.filter(x => x.Id == s).map(i => i.Name)[0];
            this.months.forEach(t => {
              let data1 = this.propertyTypeData.filter(x => x.Id == s);
              this.TypeBasedData = num <= 12 ? data1.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[0] : data1.filter(x => x.XAxis == t).map(i => i.AvgCapRate)[1];
              monthlydata.push((this.TypeBasedData != null && this.TypeBasedData != undefined)?this.TypeBasedData:0);
              num = num + 1;
            });
            let newPortfolio1 = {} as any;
            let typeColor = name == 'Medical' ? '#FF4438' : name == 'Office' ? '#FFC32B' : name == 'Industrial' ? '#003A5D' : name == 'Retail' ? '#198FDE' : this.getChartColor(chatDataColor)
            newPortfolio1 = {
              name: name,
              data: monthlydata.map(i => i),
              color: typeColor,
              marker: {
                "symbol": "circle"
              }
            };
            if (monthlydata != null && monthlydata != undefined && monthlydata.length > 0) {
              let newminimumValue = monthlydata.reduce((a, b) => Math.min(a, b));
              graphMin = (avgCapRate != null && avgCapRate != undefined && avgCapRate.length > 0) ? (newminimumValue != null && newminimumValue != undefined) ? (newminimumValue < graphMin) ? newminimumValue : graphMin : graphMin : newminimumValue;
              this.minimumValue = graphMin > 1 ? (graphMin - 1) : graphMin;
            }
            else {
              this.minimumValue = graphMin > 1 ? (graphMin - 1) : graphMin;
            }
            chatDataColor++;
            newPortfolio.push(newPortfolio1);
          });
          this.barchartData = newPortfolio;
          this.showLoader = false;
          this.bindChart();
        }
      });
    });
  }

  }
